import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// dependencies
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InventoryModule } from './inventory/inventory.module';
import { Title } from '@angular/platform-browser';
import { ExtraModule } from './extra-module/extra-module.module';
import { AdminModuleModule } from './admin-module/admin-module.module';
import { DoctorModule } from './doctor/doctor.module';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    ExtraModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    InventoryModule,
    AdminModuleModule,
    DoctorModule
  ],
  providers: [
    Title
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
